import React from 'react';
import {
  resolveEventTimeZone,
  formatSessionDateInTimeZone,
  formatSessionClockWithZone,
} from '../../utils/sessionTime';
import { formatEventLocationLabel } from '../../utils/eventLocation';
import styles from './LandingPage.module.css';

export default function Sessions({ sessions = [], event = {}, language = 'en' }) {
  if (!sessions.length) return null;

  const tz = resolveEventTimeZone(event);
  const loc = formatEventLocationLabel(event);
  const lang = String(language).toLowerCase();
  const eyebrow = lang === 'es' ? 'Agenda' : 'Schedule';
  const title = lang === 'es' ? 'Sesiones del evento' : 'Event Sessions';

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>{eyebrow}</p>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </header>
        <div className={styles.sessionsList}>
          {sessions.map((s, idx) => {
            const dateStr = s.start_time ? formatSessionDateInTimeZone(s.start_time, tz) : '';
            const timeStr = s.start_time ? formatSessionClockWithZone(s.start_time, tz) : '';
            const meta = [dateStr, timeStr, s.description].filter(Boolean).join(' · ');
            return (
              <div key={s.id ?? idx} className={styles.sessionCard}>
                <div className={styles.sessionNum}>{String(idx + 1).padStart(2, '0')}</div>
                <div>
                  <div className={styles.sessionTitle}>{s.title ?? s.name ?? `Session ${idx + 1}`}</div>
                  {meta && <div className={styles.sessionMeta}>{meta}</div>}
                </div>
                {loc ? <span className={styles.sessionBadge}>{loc}</span> : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
